import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ContainerLoadService } from "./container/container-load.service";
import { SafeHtmlPipe } from "./html/safe-html.pipe";
import { ForceSignPipe } from "./form/force-sign.pipe";
import { FormatContainerLabelPipe } from "./container/format-container-label.pipe";
import { SortEquipmentPipe } from "./container/sort-equipment.pipe";
import { CurrencyPipe } from "./currencies/currency.pipe";
import { CountryNamePipe } from "./countries/country-name.pipe";
import { CurrencyRoundPipe } from "./currencies/currency-round.pipe";
import { FileUploadModule } from "primeng/fileupload";
import { AccordionModule } from "primeng/accordion";
import { DownloadService } from "./download/download.service";
import { GoogleMapsService } from "./google-maps/google-maps.service";
import { TimeAgoPipe } from "./time-ago/time-ago.pipe";
import { ClipboardService } from "./clipboard/clipboard.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    AccordionModule,
    ForceSignPipe,
    CountryNamePipe,
    SafeHtmlPipe,
    CurrencyPipe,
    TimeAgoPipe,
    CurrencyRoundPipe,
    FormatContainerLabelPipe,
    SortEquipmentPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    AccordionModule,
    ForceSignPipe,
    CountryNamePipe,
    SafeHtmlPipe,
    CurrencyPipe,
    TimeAgoPipe,
    CurrencyRoundPipe,
    FormatContainerLabelPipe,
    SortEquipmentPipe,
  ],
  providers: [
    ContainerLoadService,
    DownloadService,
    GoogleMapsService,
    ClipboardService,
  ],
})
export class SharedModule {}
